const getUserDetails = (userId, password, tenantId) =>
  fetch(`/circulation-proxy/rest/user-details?tenant_id=${tenantId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      userId: userId,
      password: password
    })
  }).then(response => {
    if (response.status >= 400) {
      return Promise.reject(response);
    }
    return response.json();
  });

export default { getUserDetails };
